import type { AxiosInstance } from 'axios';

// Core: single endpoint to fetch summary metrics for a date range
// Placeholder path – align with backend when available
const getOwnerSummaryCore = async (
  axiosinstance: AxiosInstance,
  ownerId: string,
  startDateISO: string,
  endDateISO: string,
  auth: { accessToken?: string | null },
) => {
  return axiosinstance.get(
    `/bp_get_owner_summary_information?bp_start_date=${encodeURIComponent(
      startDateISO,
    )}&bp_end_date=${encodeURIComponent(endDateISO)}`,
    {
      headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
    },
  );
};

export type OwnerSummaryResponse = {
  duePaymentsAmount: number;
  lowStocksCount: number;
  expensesAmount: number;
  stockSellValueAmount: number;
  profitAmount: number;
  ordersCount: number;
  staffCount: number;
};

// Public wrapper
export const getOwnerSummary = async (
  axiosinstance: AxiosInstance,
  ownerId: string,
  startDateISO: string,
  endDateISO: string,
  auth: { accessToken?: string | null },
) => {
  try {
    return await getOwnerSummaryCore(
      axiosinstance,
      ownerId,
      startDateISO,
      endDateISO,
      auth,
    );
  } catch (e) {
    return Promise.reject(e);
  }
};
